import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useParams } from "react-router-dom";
import { createTheme, styled } from "@mui/material/styles";
import TabScrollButton from "@material-ui/core/TabScrollButton";
import { withStyles } from "@material-ui/core/styles";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { TabPanelProps } from "../../models/supplierSettlement/supplierSettlement.model";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function _TabPanel({
  children,
  value,
  index,
  className,
  height,
  ...other
}: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {/* <Backdrop
        hidden={true}
        sx={{ color: "#fff", zIndex: () => 10000 }}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
      {
        // value === index &&
        <Box
          sx={{
            p: 3,
            borderLeft: "1px solid #C1C7CB",
            borderRight: "1px solid #C1C7CB",
            borderBottom: "1px solid #C1C7CB",
          }}
          style={height ? { height: height } : {}}
        >
          <div className={className ? className : "tabsScroll"}>
            <div
              style={{
                direction: "rtl",
                marginLeft: "1.5vh",
                marginTop: "1.5vh",
              }}
            >
              <Typography>{children}</Typography>
            </div>
          </div>
        </Box>
      }
    </div>
  );
}

function tabProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
interface tabsInterface {
  tab: any;
  // tabPanel:any
}

export default function TabPanelCmp(props: any) {
  const jsonFile = useSelector((state: any) => state.style);

  const [value, setValue] = React.useState(0);
  const [color, setColor] = React.useState<string>("#FF9100 !important");
  const [tabHeadercolor, setTabHeadercolor] = React.useState<string>("#FF9100");

  const { customerNationalCode, loanRequestId } = useParams<any>();

  React.useEffect(() => {
    if (props.setActiveTab) {
      props.setActiveTab(value);
    }
  }, [value]);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (event.currentTarget.textContent === "تحویل شده") {
      setColor("#01AF43 !important");
      setTabHeadercolor("#01AF43");
    } else if (event.currentTarget.textContent === "در جریان") {
      setColor("#FF9100 !important");
      setTabHeadercolor("#FF9100");
    } else if (event.currentTarget.textContent === "لغو شده") {
      setColor("#E6123D !important");
      setTabHeadercolor("#E6123D");
    }
    setValue(newValue);
  };

  const StyledTab = styled(Tab)({
    color: props.from ? "#1D4A87" : "",
    "&.Mui-selected": {
      color: props.from ? color : "#1d4a87 !important",
      background: "white !important",
      alignItems: "center",
      borderRight: "2px solid #C1C7CB",
      borderLeft: "2px solid #C1C7CB !important",
      borderBottom: "2px solid white !important",
      boxShadow: "0 4px 0 -2px white !important",
    },
    "&.MuiSvgIcon-root": {
      width: "24px",
      height: "24px",
    },
    "&.MuiTab-root": {
      color: props.from ? "" : "#1d4a87 !important",
    },
  });

  const MyTabScrollButton = withStyles((theme) => ({
    root: {
      width: 28,
      overflow: "hidden",
      transition: "width 0.5s",
      direction: "rtl",

      "&.Mui-disabled": {
        width: 0,
      },
    },
  }))(TabScrollButton);

  // TabIndicatorProps={
  //   tab.map((item: any) => (

  //     !item.hasError ? {
  //       style: {
  //         background: "#01af43",
  //         top: 0,
  //         height: "4px ",

  //       },
  //     } : {
  //       style: {
  //         background: "#E6123D",
  //         top: 0,
  //         height: "4px ",

  //       },
  //     }
  //   ))
  // }
  return (
    <Box sx={{ margin: "1.9vh", direction: "rtl", overflowX: "auto" }}>
      <Box
        style={{
          overflowX: "auto",
          borderBottom: props.tab.length > 0 ? "1px solid #c1c7cb" : "",
        }}
        // className={props.tab.length > 0 ? "borderBottomTab" : ""}
      >
        {/* */}
        <Tabs
          variant="scrollable"
          scrollButtons="auto"
          ScrollButtonComponent={MyTabScrollButton}
          allowScrollButtonsMobile
          value={value}
          onChange={handleChange}
          style={{ overflowX: "auto", width: "max-content" }}
          textColor="secondary"
          indicatorColor="secondary"
          TabIndicatorProps={
            !props.showError
              ? {
                  style: {
                    background: props.from
                      ? tabHeadercolor
                      : `${jsonFile?.mainColor}`,
                    top: 0,
                    height: "4px ",
                  },
                }
              : {
                  style: {
                    background: "#E6123D",
                    top: 0,
                    height: "4px ",
                  },
                }
          }
        >
          {props.tab.map((item: any) => (
            //
            <StyledTab
              label={<div style={{ marginRight: "5px" }}>{item.title}</div>}
              icon={
                item.hasError ? (
                  <ReportProblemIcon style={{ color: "#E6123D" }} />
                ) : (
                  item.icon
                )
              }
              {...tabProps(0)}
              key={item.id}
              style={{
                borderLeft: "2px solid white",
                height: "50px",
                minHeight: "50px",
                alignItems: "center",
                background: item.hasError ? "#FDF1F3" : "#F6F8F9",
                flexDirection: "row",
                padding: "20px",
                fontSize: "13px",
                fontWeight: "bold",
              }}
            />
          ))}
        </Tabs>
      </Box>
      {props.tab.map((item: any) => (
        <_TabPanel
          value={value}
          index={item.id}
          key={item.id}
          className={props?.class}
          height={props?.height}
        >
          {item.child}
        </_TabPanel>
      ))}
    </Box>
  );
}
